import * as React from 'react'

import { inject, observer } from 'mobx-react'

import MobileInitialState from '~/client/src/mobile/stores/MobileInitialState'
import { Loader } from '~/client/src/shared/components/Loader'
import {
  Drawer,
  DrawerContent,
} from '~/client/src/shared/components/shadcn-ui/drawer'
import { SidePanelOverlayProvider } from '~/client/src/shared/components/SidePanel/SidePanelOverlayContext'
import WorkflowViewFormWrapper from '~/client/src/shared/components/SitePermitCreationForm/WorkflowViewFormWrapper'
import useWorkflowById from '~/client/src/shared/hooks/useWorkflowById'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import CompaniesStore from '~/client/src/shared/stores/domain/Companies.store'
import FormCategoriesStore from '~/client/src/shared/stores/domain/FormCategories.store'
import PermitTypesStore from '~/client/src/shared/stores/domain/PermitTypes.store'

import MobileFileInput from '../FileInput/MobileFileInput'

interface IProps {
  state?: MobileInitialState
}

interface IBodyProps {
  workflowId: string

  state?: MobileInitialState
  permitTypesStore?: PermitTypesStore
  companiesStore?: CompaniesStore
  formCategoriesStore?: FormCategoriesStore
}

const MobileWorkflowDrawerBodyComponent: React.FC<IBodyProps> = ({
  workflowId,
  state,
  permitTypesStore,
  companiesStore,
  formCategoriesStore,
}) => {
  const { workflow, workflowLoading } = useWorkflowById(
    state.activeProject.id,
    workflowId,
  )

  const isDataReceived =
    permitTypesStore.isDataReceived &&
    companiesStore.isDataReceived &&
    formCategoriesStore.isDataReceived

  if (workflowLoading || !isDataReceived) {
    return (
      <div className="tw:flex tw:flex-1 tw:items-center tw:justify-center">
        <Loader size="md" />
      </div>
    )
  }

  if (!workflow) {
    return (
      <div className="tw:flex tw:flex-1 tw:flex-col tw:items-center tw:justify-center tw:gap-4 tw:p-6 tw:text-center">
        <p className="tw:text-lg tw:text-foreground">
          {Localization.translator.workflowDeleted}
        </p>
        <button
          className="tw:text-primary tw:underline"
          onClick={state.resetWorkflowIdDisplayedOnGlobalCard}
        >
          {Localization.translator.goBack}
        </button>
      </div>
    )
  }

  return (
    <WorkflowViewFormWrapper
      key={workflow.id}
      workflowToShow={workflow}
      onClose={state.resetWorkflowIdDisplayedOnGlobalCard}
      FileInputType={MobileFileInput}
      isMobileMode={true}
      openWorkflow={w => state.setWorkflowIdDisplayedOnGlobalCard(w.id)}
    />
  )
}

const MobileWorkflowDrawerBody = inject(
  'state',
  'permitTypesStore',
  'companiesStore',
  'formCategoriesStore',
)(observer(MobileWorkflowDrawerBodyComponent))

const MobileWorkflowDrawerComponent: React.FC<IProps> = ({ state }) => {
  const workflowId = state.workflowIdDisplayedOnGlobalCard

  return (
    <Drawer
      open={!!workflowId}
      onOpenChange={nextOpen => {
        if (!nextOpen) {
          state.resetWorkflowIdDisplayedOnGlobalCard()
        }
      }}
    >
      <DrawerContent
        className="tw:h-[90vh] tw:max-h-[90vh] tw:min-h-0 tw:outline-none"
        onPointerDownOutside={event => {
          const target = event.target as Element | null
          if (target?.closest('[data-user-card-portal]')) {
            event.preventDefault()
          }
        }}
      >
        <div className="tw:relative tw:flex tw:flex-1 tw:min-h-0 tw:flex-col">
          <SidePanelOverlayProvider>
            {!!workflowId && (
              <MobileWorkflowDrawerBody
                key={workflowId}
                workflowId={workflowId}
              />
            )}
          </SidePanelOverlayProvider>
        </div>
      </DrawerContent>
    </Drawer>
  )
}

const MobileWorkflowDrawer = inject('state')(
  observer(MobileWorkflowDrawerComponent),
)

export default MobileWorkflowDrawer
